import React from 'react';
import { Table } from 'antd';
import { Pencil, Ban, CircleCheck, ImageOff, Package } from 'lucide-react';
import { IconAction, IconActions, StatusTag, EmptyState } from '../../common';

/** Catalog thumbnail: `images` may be a plain URL or { thumbnail, uri }. */
const resolveImageUrl = (record) => {
    if (!record) return '';
    if (typeof record.images === 'string') return record.images;
    return record?.images?.thumbnail || record?.images?.uri || '';
};

export default function ProductsTable({ rows, loading, onEdit, onToggleActive }) {
    const columns = [
        {
            title: 'Imagen',
            key: 'image',
            width: 80,
            render: (_, record) => {
                const imageUrl = resolveImageUrl(record);
                return imageUrl ? (
                    <img src={imageUrl} alt={record?.name || 'Producto'} className="h-10 w-10 rounded-lg border border-surface-200 bg-white object-cover" />
                ) : (
                    <span className="flex h-10 w-10 items-center justify-center rounded-lg border border-dashed border-surface-300 bg-surface-50 text-surface-300">
                        <ImageOff />
                    </span>
                );
            }
        },
        {
            title: 'Nombre',
            dataIndex: 'name',
            key: 'name',
            sorter: (a, b) => (a.name || '').localeCompare(b.name || ''),
            render: (name) => <span className="text-sm font-medium text-surface-900">{name}</span>
        },
        {
            title: 'Código',
            dataIndex: 'value',
            key: 'value',
            sorter: (a, b) => (a.value || '').localeCompare(b.value || ''),
            render: (value) => <span className="font-mono text-xs text-surface-600">{value}</span>
        },
        {
            title: 'Categoría',
            dataIndex: 'category',
            key: 'category',
            render: (category) => (category ? <StatusTag tone="neutral">{category}</StatusTag> : <span className="text-surface-300">--</span>)
        },
        {
            title: 'Estado',
            dataIndex: 'active',
            key: 'active',
            render: (active) => (
                <StatusTag tone={active ? 'success' : 'danger'} dot>
                    {active ? 'Activo' : 'Inactivo'}
                </StatusTag>
            )
        },
        {
            title: 'Acciones',
            key: 'actions',
            align: 'right',
            width: 100,
            render: (_, record) => (
                <IconActions>
                    <IconAction icon={<Pencil />} label="Editar" onClick={() => onEdit(record)} />
                    <IconAction
                        icon={record.active ? <Ban /> : <CircleCheck />}
                        label={record.active ? 'Desactivar' : 'Activar'}
                        danger={record.active}
                        onClick={() => onToggleActive(record)}
                        confirm={{
                            title: record.active ? '¿Desactivar producto?' : '¿Reactivar producto?',
                            okText: 'Sí',
                            cancelText: 'No'
                        }}
                    />
                </IconActions>
            )
        }
    ];

    return (
        <Table
            dataSource={rows}
            loading={loading}
            columns={columns}
            size="middle"
            rowKey={(record) => record._id || record.value}
            pagination={{ pageSize: 20, showSizeChanger: true }}
            scroll={{ x: 720 }}
            locale={{ emptyText: <EmptyState icon={<Package />} title="No hay productos" description="Prueba con otra búsqueda o crea un producto nuevo." /> }}
        />
    );
}
